var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThunderAuto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 80,
    viewBox: "0 0 64 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_498_7093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0504 76.8053C17.536 76.8053 17.0099 76.7169 16.4867 76.5356C14.366 75.8002 13.1473 73.8107 13.4582 71.5868L16.8508 47.3484H6.42118C5.13314 47.3484 3.91141 46.7884 3.07139 45.8128C2.23136 44.8372 1.85851 43.5477 2.04862 42.2743L6.89866 9.76832C7.21994 7.61963 9.09894 6 11.2712 6H27.5824C29.012 6 30.3589 6.6956 31.1872 7.86132C32.0154 9.02704 32.2276 10.5273 31.7575 11.8772L25.0403 31.1374H39.5712C41.1746 31.1374 42.6086 31.9671 43.4059 33.3583C44.2046 34.748 44.1973 36.4045 43.3882 37.7883L21.9292 74.5239C21.0759 75.9859 19.6214 76.8053 18.0504 76.8053Z",
    fill: "url(#paint0_linear_498_7093)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6981 6.20883C29.4136 7.21591 29.5972 8.51309 29.1909 9.6799L22.4737 28.9398L22.1956 29.7374H23.0403H37.5712C38.9599 29.7374 40.1951 30.4523 40.8853 31.6566L40.8857 31.6573C41.577 32.8602 41.5709 34.287 40.8702 35.4855L40.8701 35.4857L19.4111 72.2213L19.411 72.2215C18.6628 73.5035 17.4031 74.2053 16.0504 74.2053C15.6053 74.2053 15.1455 74.1288 14.6833 73.9687C12.8331 73.3271 11.7812 71.6097 12.0524 69.6699L15.445 45.4316L15.5406 44.7484H14.8508H4.42118C3.3077 44.7484 2.25203 44.2644 1.52607 43.4213C0.799863 42.5779 0.477711 41.4636 0.642043 40.3629L0.642052 40.3629L5.49207 7.85705C5.49207 7.85699 5.49208 7.85693 5.49209 7.85687C5.76954 6.00194 7.39627 4.6 9.27122 4.6H25.5824C26.8175 4.6 27.9823 5.20142 28.6981 6.20883ZM0.0486437 40.2744L0.0486663 40.2744L0.0486437 40.2744Z",
    stroke: "url(#paint1_linear_498_7093)",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_498_7093)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 24.8053,
    width: 46,
    height: 19,
    rx: 9.5,
    fill: "#E25683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.91 38.3053L21.03 31.3053H22.63L25.76 38.3053H24.06L21.5 32.1253H22.14L19.57 38.3053H17.91ZM19.47 36.8053L19.9 35.5753H23.5L23.94 36.8053H19.47ZM29.4498 38.4253C28.4564 38.4253 27.6798 38.1486 27.1198 37.5953C26.5598 37.042 26.2798 36.252 26.2798 35.2253V31.3053H27.8998V35.1653C27.8998 35.832 28.0364 36.312 28.3098 36.6053C28.5831 36.8986 28.9664 37.0453 29.4598 37.0453C29.9531 37.0453 30.3364 36.8986 30.6098 36.6053C30.8831 36.312 31.0198 35.832 31.0198 35.1653V31.3053H32.6198V35.2253C32.6198 36.252 32.3398 37.042 31.7798 37.5953C31.2198 38.1486 30.4431 38.4253 29.4498 38.4253ZM35.5534 38.3053V32.6253H33.3134V31.3053H39.4134V32.6253H37.1734V38.3053H35.5534ZM43.5874 38.4253C43.0341 38.4253 42.5208 38.3353 42.0474 38.1553C41.5808 37.9753 41.1741 37.722 40.8274 37.3953C40.4874 37.0686 40.2208 36.6853 40.0274 36.2453C39.8408 35.8053 39.7474 35.3253 39.7474 34.8053C39.7474 34.2853 39.8408 33.8053 40.0274 33.3653C40.2208 32.9253 40.4908 32.542 40.8374 32.2153C41.1841 31.8886 41.5908 31.6353 42.0574 31.4553C42.5241 31.2753 43.0308 31.1853 43.5774 31.1853C44.1308 31.1853 44.6374 31.2753 45.0974 31.4553C45.5641 31.6353 45.9674 31.8886 46.3074 32.2153C46.6541 32.542 46.9241 32.9253 47.1174 33.3653C47.3108 33.7986 47.4074 34.2786 47.4074 34.8053C47.4074 35.3253 47.3108 35.8086 47.1174 36.2553C46.9241 36.6953 46.6541 37.0786 46.3074 37.4053C45.9674 37.7253 45.5641 37.9753 45.0974 38.1553C44.6374 38.3353 44.1341 38.4253 43.5874 38.4253ZM43.5774 37.0453C43.8908 37.0453 44.1774 36.992 44.4374 36.8853C44.7041 36.7786 44.9374 36.6253 45.1374 36.4253C45.3374 36.2253 45.4908 35.9886 45.5974 35.7153C45.7108 35.442 45.7674 35.1386 45.7674 34.8053C45.7674 34.472 45.7108 34.1686 45.5974 33.8953C45.4908 33.622 45.3374 33.3853 45.1374 33.1853C44.9441 32.9853 44.7141 32.832 44.4474 32.7253C44.1808 32.6186 43.8908 32.5653 43.5774 32.5653C43.2641 32.5653 42.9741 32.6186 42.7074 32.7253C42.4474 32.832 42.2174 32.9853 42.0174 33.1853C41.8174 33.3853 41.6608 33.622 41.5474 33.8953C41.4408 34.1686 41.3874 34.472 41.3874 34.8053C41.3874 35.132 41.4408 35.4353 41.5474 35.7153C41.6608 35.9886 41.8141 36.2253 42.0074 36.4253C42.2074 36.6253 42.4408 36.7786 42.7074 36.8853C42.9741 36.992 43.2641 37.0453 43.5774 37.0453Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_498_7093",
    x: -8.95235,
    y: 18.4878,
    width: 83.9047,
    height: 56.9047,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.394841
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_498_7093"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.57936
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.36904
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_498_7093",
    result: "effect2_dropShadow_498_7093"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12.6349
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.47618
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_498_7093",
    result: "effect3_dropShadow_498_7093"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_498_7093",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_498_7093",
    x1: 23,
    y1: 6,
    x2: 23,
    y2: 82.6688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_498_7093",
    x1: 74,
    y1: -23.5974,
    x2: 6.50001,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_498_7093"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 80,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunderAuto);
export default __webpack_public_path__ + "static/media/thunder-auto.c037bb81fd9413c0990e32eb09749958.svg";
export { ForwardRef as ReactComponent };